import Footer from "@/Screen/System/Footer";
import Header from "@/Screen/System/Header";
import Aside from "@/Screen/System/Aside";
import SideHelpUI from "@/UI/BaseComponents/Help/sideHelpUI";
import ShortHelpUI from "@/UI/BaseComponents/Help/shortHelpUI";
import { AlignLoader } from "AlignComponents";
import React from 'react';
// import ReactHintFactory from "react-hint";
import { Container } from "react-bootstrap";
import NewPasswordPrompt from "@/UI/BaseComponents/NewPasswordPrompt";
import classNames from "classnames";
import Tabs from "@/Screen/System/Tab";
import { getLayout } from "@/Utils/auth";

export const AlignUIRender = ({ sideBarState, ...props }: any) => (
  <Container fluid className={classNames(["p-0", { unpinned: sideBarState == "unpinned" }])}>
    <NewPasswordPrompt />
    <Aside />
    <Container fluid className={classNames(["auth-container"])}>
      <Header />
      <Container fluid className='content'>
        {props.children}
        <SideHelpUI />
        {/* <ShortHelpUI /> */}
      </Container>
    </Container>
  </Container>
);
